import React, { type FC, memo, useCallback, useMemo } from 'react';

import { Select } from '@/shared/components/Select/Select';
import { useDisplayLanguage } from '@/shared/hooks/useDisplayLanguage';
import { clientConfig } from '@/config/client';

const {
    i18n: { displayLanguages = [] },
} = clientConfig;

const GlobalIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
        <path
            fill="#fff"
            d="M8.343 1.342A6.667 6.667 0 0 1 14.666 8l-.009.343A6.666 6.666 0 0 1 8 14.666l-.344-.009a6.667 6.667 0 0 1-6.314-6.314L1.333 8A6.67 6.67 0 0 1 8 1.333zM6.497 8.799c.109 1.448.5 2.521.878 3.247.223.428.445.74.604.938l.02.024.022-.024c.158-.198.38-.51.603-.938.379-.726.77-1.798.879-3.247zm4.61 0c-.106 1.623-.524 2.881-.972 3.795a5.07 5.07 0 0 0 2.868-3.795zm-8.11 0a5.07 5.07 0 0 0 2.865 3.794c-.447-.914-.864-2.172-.97-3.794zm2.865-5.394A5.07 5.07 0 0 0 2.996 7.2h1.897c.105-1.622.522-2.88.97-3.794m2.117-.39c-.16.198-.38.51-.604.938-.379.726-.769 1.798-.878 3.246h3.006c-.109-1.448-.5-2.52-.879-3.246a6 6 0 0 0-.603-.938Q8.01 3 7.999 2.989zm2.156.39c.448.913.866 2.171.971 3.794h1.897a5.07 5.07 0 0 0-2.868-3.795"
        />
    </svg>
);

export const LanguageSwitcher: FC = memo(() => {
    const [displayLanguage, setDisplayLanguage] = useDisplayLanguage();

    const options = useMemo(
        () =>
            displayLanguages.map((language) => ({
                label: language.title,
                value: language.code,
                icon: language.shortTitle,
            })),
        []
    );

    const handleLanguageChange = useCallback((lang: string | null) => {
        const isValid = displayLanguages.some((l) => l.code === lang);

        if (isValid) {
            setDisplayLanguage(lang as string);
        } else {
            console.error(`Invalid language code: ${lang}`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Select
            options={options}
            icon={<GlobalIcon />}
            value={displayLanguage?.code ?? null}
            onChange={handleLanguageChange}
        />
    );
});

LanguageSwitcher.displayName = 'LanguageSwitcher';
